<template>
    <div 
		class="summationBox"
		v-if="resultList.length >= 0"
		>
		<div class="itemName">
			费用合计
		</div>
		<el-table
			:data="resultList"
			style="max-width: 1200px"
			show-summary
			:summary-method="summaryMethod"
			:header-row-style="{ color: '#333', fontWeight: 600 }"
			>
			<el-table-column
				prop="engineeringName"
				align="right"
				>
				<template slot-scope="scope">
					<span style="color: #333333; font-weight: 600;">{{ scope.row.engineeringName }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="beforeSummation"
				label="折前费用（元）"
				align="center"
				>
				<template slot-scope="scope">
					<span style="color: #333333;">{{ scope.row.beforeSummation }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="discountRatio"
				label="打折系数（%）"
				align="center"
				>
				<template slot-scope="scope">
					<span style="color: #1F80EA;">{{ scope.row.discountRatio || '/' }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="summation"
				label="折后费用（元）"
				align="center"
				>
				<template slot-scope="scope">
					<span style="color: #FF0000; font-weight: 600;">{{ scope.row.summation }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="address"
				label="计算依据"
				>
				<template slot-scope="scope">
					<span 
						v-if="scope.row.basicCriterionFileUrl"
						@click="showFilePreview(scope.row.basicCriterion, scope.row.basicCriterionFileUrl)"
						style="color: #1F80EA; cursor: pointer;"
						>
						{{ scope.row.basicCriterion }}
					</span>
					<span v-else>
						{{ scope.row.basicCriterion }}
					</span>
				</template>
			</el-table-column>
		</el-table>
		<PreviewFile ref="previewFile"/>
    </div>
</template>
<script>

import PreviewFile from './PreviewFile.vue'

export default {
	components: {
		PreviewFile
	},
    props: {
        resultList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
			cityList: [],
			provience: ''
        }
    },
    methods: {
		summaryMethod(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总价';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value)) && (index == 1 || index == 3) ) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0).toFixed(2);
				}
			});

			return sums;
		},

		showFilePreview(fileName, fileUrl) {
			this.$refs.previewFile.show(fileName, fileUrl)
		}
    },
	mounted() {
	}
}
</script>

<style lang="scss" scoped>
	.summationBox {
		background: white;
		border-radius: 5px;
		position: relative;
		padding: 60px 78px;

		.itemName {
			position: absolute;
			top: 0;
			left: 0;
			background: #FF6E0A;
			border-radius: 0px 0px 36px 0px;
			height: 46px;
			line-height: 46px;
			font-size: 16px;
			color: #FFFFFF;
			padding: 0 30px 0 16px;
		}

		::v-deep .el-table__footer {
			tr {
				background-color: #FFEEDD !important; // 自定义背景颜色
				td {
					color: #FF0000 !important; // 自定义字体颜色
					font-weight: 600;
				}
			}
		}
	}
</style>
